/**
 * useFeatureFlag -- Single flag hook
 *
 * Usage:
 *   const { enabled, loading } = useFeatureFlag('profile_settings_v1')
 *   if (!enabled) return null
 *
 * Returns immediately (sync) from cache. Re-renders when cache updates.
 * If the flag is store-scoped, uses the current store from FeatureFlagProvider context.
 */

import { useFeatureFlagContext } from './FeatureFlagProvider'
import { IFeatureFlagState } from './featureFlags.types'

export function useFeatureFlag (flagName: string, storeId?: string | null): IFeatureFlagState {
    const ctx = useFeatureFlagContext()
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const _version = ctx.version // subscribe to updates
    return ctx.getFlag(flagName, storeId)
}
